<template>
  <div class="wrapper">
    <div class="form-group">
      <label>Vorlage:</label>
      <div class="input-group">
        <select v-model="selectedProfile" class="form-control" @change="selectProfile">
          <option v-for="p,index in profiles" :key="index" :value="p.id">{{ p.name }}</option>
        </select>
        <div class="input-group-append">
          <button @click="toggleEdit" class="btn btn-secondary"><font-awesome-icon icon="edit"/></button>
          <button @click="newProfile" class="btn btn-primary"><font-awesome-icon icon="plus"/></button>
        </div>
      </div>
    </div>
    <div class="form-check" v-if="download">
      <input class="form-check-input" v-model="config.download" type="checkbox" value="" id="checkDefault">
      <label class="form-check-label" for="checkDefault">
        Download
      </label>
    </div>
    <div class="row" v-show="showEdit">
      <div class="col">
        <div class="form-group">
          <label>Name</label>
          <div class="input-group">
            <input type="text" class="form-control" v-model="config.name"/>
            <div class="input-group-append">
              <button class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
              <button @click="saveExportProfile" class="btn btn-primary"><font-awesome-icon icon="save"/></button>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Export-Type</label>
          <select @change="onChangeType" class="form-control" v-model="config.exporttype">
            <option value="text">Text</option>
            <option value="xls">Excel</option>
            <option value="json">Plain JSON</option>
            <option value="sql">SQL Tabelle</option>
          </select>
        </div>
        <div v-if="!(config.exporttype == 'sql')" class="form-group">
          <label>Ausgabe:</label>
          <input type="text" class="form-control" v-model="config.exportoutput"/>
        </div>
        <div v-else class="form-group">
          <label>Ausgabe:</label>
          <select class="form-control" v-model="config.exportoutput">
            <option v-for="db,index in databases" :key="index" :value="db.name">{{ db.name }}</option>
          </select>
        </div>
        <div class="form-group" v-show="!['json','sql'].includes(config.exporttype)">
          <label>Template-Datei:</label>
          <input type="text" class="form-control" v-model="config.exporttemplate"/>
        </div>
      </div>
      <div class="col">
        <div class="form-group" v-show="config.exporttype == 'text'">
          <label>Text-Template:</label>
          <textarea rows="12" class="form-control" v-model="config.extend.template">

          </textarea>
        </div>
        <div v-if="['xls','sql'].includes(config.exporttype)" class="form-group">
          <label>Tabelle</label>
          <input type="text" class="form-control" v-model="config.exportsheet"/>
        </div>
        <div v-if="['xls','sql'].includes(config.exporttype)" class="form-group">
          <label>Spalten</label>
          <div class="input-group">
            <input type="text" list="attributeids" v-model="column.attribute" class="form-control" placeholder="Attribute..."/>
            <datalist id="attributeids">
              <option v-for="c,index in columns" :key="index" :value="c"></option>
            </datalist>
            <input type="text" v-model="column.name" class="form-control" placeholder="Spalte..."/>
            <div class="input-group-append">
              <button @click="addColumn" class="btn btn-primary"><font-awesome-icon icon="plus"/></button>
            </div>
          </div>
        </div>
        <div style="max-height: 300px; overflow: auto;">
          <table class="table table-striped table-sm" v-if="['xls','sql'].includes(config.exporttype)">
            <tbody>
              <tr v-for="c,index in config.extend.columns" :key="index">
                <td>{{ c.attribute }}</td>
                <td>{{ c.name }}</td>
                <td><button @click="remColumn(index)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datamap from '@/modules/datamap.js'

export default {
  name: 'ExportConfigWidget',
  props: ["config","columns","download"],
  data() {
    return {
      showEdit: false,
      profiles: [],
      selectedProfile: -1,
      databases: [],
      column: {
        attribute: "",
        name: ""
      }
    }
  },
  created() {
    this.fetchProfiles();
    this.fetchDatabases();
  },
  mounted() {
    console.log("widget cols:",this.columns);
  },
  methods: {
    onChangeType() {
      if (["text","json","xls"].indexOf(this.config.exporttype) >= 0) {
        this.config.download = false;
      }
      this.$forceUpdate();
    },
    remColumn(idx) {
      if (this.config.extend.columns && this.config.extend.columns.length >= idx) {
        this.config.extend.columns.splice(idx,1);
      }
      this.$forceUpdate();
    },
    addColumn() {
      console.log('add column:',this.column);
      this.config.extend.columns = this.config.extend.columns || [];
      this.config.extend.columns.push({"attribute":this.column.attribute,"name":this.column.name});
      this.column.name = "";
      this.column.attribute = "";
      this.$forceUpdate();
    },
    newProfile() {
      this.showEdit = true;
      this.config.id = -1;
      this.config.name = '';
      this.config.extend = {};
      this.config.exportoutput = '';
      this.config.exporttemplate = '';
      this.config.exporttype = '';
      this.config.exportsheet = '';
      this.config.download = false;
    },
    toggleEdit() {
      this.showEdit = !this.showEdit;
    },
    copyProfile(profile) {
        this.config.id             = profile.id;
        this.config.name           = profile.name;
        this.config.extend         = profile.extend || {};
        this.config.exportsheet    = profile.exportsheet;
        this.config.exportoutput   = profile.exportoutput;
        this.config.exporttype     = profile.exporttype;
        this.config.exporttemplate = profile.exporttemplate;
        this.config.download       = profile.download;
    },
    selectProfile() {
      console.log(this.selectedProfile);
      var self = this;
      var pselect = this.profiles.filter((e) => {
        return (e.id == self.selectedProfile);
      });
      console.log(pselect,this.profiles);
      if (pselect.length > 0) {
        var profile = pselect[0];
        this.copyProfile(profile);
      } else {
        this.config.id = -1;
        this.selectedProfile = -1;
        this.config.name = '';
        this.config.extend = {};
      }
    },
    fetchProfiles() {
      var self = this;
      fetch('/trendshop.proxy.web/rest/datamap/exportprofiles/',{credentials:'include'}).then(resp => resp.json()).then(function(data) {
        self.profiles = data;
      }).catch((err) => {
        self.$bvToast.toast('Fehler beim Laden der Export-Profile: ' + err,{variant:'danger',title:'ExportProfile'});
      })
    },
    fetchDatabases() {
      var self = this;
      datamap.listsources(this,0,1000,function(data) {
        self.databases = data.filter((ds) => {
          return ds.type == "sql";
        });
      });      
    },
    saveExportProfile() {
      if (!this.config.name || this.config.name == '') {
        this.$bvToast.toast('Bitte zuerst einen Namen hinterlegen.',{title:'ExportProfile',variant:'warning'});
        return;
      }
      var self = this;
      fetch('/trendshop.proxy.web/rest/datamap/exportprofiles/',{credentials:'include',method:'POST',body: JSON.stringify(this.config)}).then(resp => resp.json()).then(function(data) {
        console.log('profile:',data);
        self.copyProfile(data);
        self.fetchProfiles();
      }).catch((error) => {
        self.$bvToast.toast('Fehler beim Speichern des Profils: ' + error,{variant:'danger',title:'ExportProfil'});
      })
    }
  }
}
</script>
